export default "/images/2366787b93633b87e6e4492c8749ba07.avif";